import { format } from "date-fns";

export enum DateFormat {
  MMMM = "MMMM",
  MMM_do_yyyy = "MMM, do, yyyy",
  MMM_do = "MMM, do",
  d_MMM = "d MMM",
  d_MMM_yyyy = "d MMM yyyy",
  yyyy_MM_dd = "yyyy-MM-dd",
  DD_MM_YYYY = "dd.MM.yyyy",
}

export const formatDate = (
  value: string = "",
  dateFormat: DateFormat = DateFormat.MMM_do_yyyy
) => {
  return value ? format(new Date(value), dateFormat) : "";
};
